// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1XfNm","title":"BackImages_title__39K3F","images":"BackImages_images__21vgr"};